export default __webpack_public_path__ + "static/media/loader-review2.6f12e340.gif";